"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Button_1 = __importDefault(require("../../../../components/Button"));
var hooks_1 = require("../../hooks");
function MultiImagePickerSelectButton(_a) {
    var as = _a.as, children = _a.children, style = _a.style, className = _a.className;
    var _b = (0, hooks_1.useMultiImagePicker)(), getRootProps = _b.getRootProps, getInputProps = _b.getInputProps;
    return (react_1.default.createElement("div", __assign({}, getRootProps({ className: "dropzone" }), { style: { width: "fit-content" } }),
        react_1.default.createElement("input", __assign({}, getInputProps())),
        as || (react_1.default.createElement(Button_1.default, { variant: "primary", format: "link", size: "small", className: className, style: style }, children))));
}
exports.default = MultiImagePickerSelectButton;
//# sourceMappingURL=index.js.map